'use strict';

import appStore from '@uw-it-sis/lib-react/lib/AppStore';

const httpClient = appStore.getHttpClient();

class Api {
    constructor() {
        this.baseUrl = 'api';
    }

    getDegreePrograms() {
        return httpClient.doGet(`${this.baseUrl}/programs`, 'getDegreePrograms');
    }
}

export default new Api();